/* Usuário de cliente (licença do módulo NF): a tela esconde o que é só do
   escritório. Quem garante de verdade é o servidor (services/portal.js no
   backend) -- isto aqui só evita mostrar botão que daria 403. */
export function ehPortal() {
  try {
    return JSON.parse(localStorage.getItem('erp_perm') || 'null')?.tipo === 'cliente';
  } catch {
    return false;
  }
}

/* primeira tela que o cliente pode abrir, pela ordem do menu NF */
export const ROTAS_PORTAL = [
  { key: 'nf', path: '/app/nf' },
  { key: 'nf/consulta', path: '/app/nf/consulta' },
  { key: 'nf/produtos', path: '/app/nf/produtos' },
  { key: 'nf/cte', path: '/app/nf/cte' },
  { key: 'nf/nfce', path: '/app/nf/nfce' },
];
